/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Kids Home API
 * Gamified family chore / habit / allowance API
 * OpenAPI spec version: 1.0.0
 */

export type QuestObjectiveResponseSourceKind =
  (typeof QuestObjectiveResponseSourceKind)[keyof typeof QuestObjectiveResponseSourceKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestObjectiveResponseSourceKind = {
  chore: 'chore',
  habit: 'habit',
  both: 'both',
  milestone: 'milestone',
  together: 'together',
  coins: 'coins',
} as const;
